import '../src/jquery_global.js'
import '../src/rails_ujs_shim.js'
import * as bootstrap from 'bootstrap'
import '../src/bootstrap_confirm.js'
import '../src/ajax_purge_image.js'
import 'datatables.net'
import 'selectize'
import flatpickr from 'flatpickr'
import { Polish } from 'flatpickr/dist/l10n/pl.js'
import Alpine from 'alpinejs'
import jQueryBridget from 'jquery-bridget'
import Draggabilly from 'draggabilly'
import TablePosition from '../src/table_position'
import bootbox from 'bootbox'

const $ = window.jQuery

window.bootstrap = bootstrap
flatpickr.localize(Polish)
window.flatpickr = flatpickr
window.bootbox = bootbox

jQueryBridget('draggabilly', Draggabilly, $)
window.TablePosition = TablePosition

import '../admin/jquery.easing.js'
import '../admin/jquery.valtastic.js'
import '../admin/jquery.autocomplete.min.js'
import '../admin/jquery.colorbox-min.js'
import '../admin/colorbox-turbolinks.js'
import '../admin/highlight.js'
import '../admin/undo_delete.js'
import '../admin/custom.js'
import '../admin/label_designer.js'

window.Alpine = Alpine

// Komponent Alpine: formularz posiłku z dynamicznym vendorem/kategoriami
Alpine.data('mealForm', (initialMealType, initialVendorId, initialVendorCategories) => ({
  mealType: String(initialMealType || 1),
  vendorId: initialVendorId ? String(initialVendorId) : '',
  vendorCategoryId: '',
  vendorCategories: initialVendorCategories || [],

  get showVendor() {
    return this.mealType == 1 || this.mealType == 3
  },

  init() {
    const existingVcId = this.$el.dataset.vendorCategoryId
    if (existingVcId) this.vendorCategoryId = existingVcId
  },

  onMealTypeChange(e) {
    this.mealType = e.target.value
  },

  onVendorChange(e) {
    this.vendorId = e.target.value
    this.vendorCategoryId = ''
    this.vendorCategories = []
    if (this.vendorId) {
      this.fetchVendorCategories(this.vendorId)
    }
  },

  fetchVendorCategories(vendorId) {
    fetch('/admin/meals/vendor_categories?vendor_id=' + vendorId, {
      headers: { 'Accept': 'application/json' }
    })
      .then(r => r.json())
      .then(data => { this.vendorCategories = data })
      .catch(() => { this.vendorCategories = [] })
  }
}))

Alpine.start()

$(function() {
  ;(window.adminQueue || []).forEach(function(fn) { fn() })
  window.adminReady = function(fn) { fn() }

  // AdminLTE sidebar toggle (data-lte-toggle="sidebar")
  $(document).on('click', '[data-lte-toggle="sidebar"]', function(e) {
    e.preventDefault()
    if (window.innerWidth >= 992) {
      // Desktop: zwiń do samych ikon / rozwiń, stan zapamiętany w przeglądarce
      const collapsed = document.body.classList.toggle('sidebar-collapse')
      try { localStorage.setItem('sidebar-collapsed', collapsed ? '1' : '0') } catch (err) {}
    } else {
      document.body.classList.toggle('sidebar-open')
    }
  })
  // Zamknij sidebar przez overlay
  $(document).on('click', '.sidebar-overlay', function() {
    document.body.classList.remove('sidebar-open')
  })

  // Przycisk "Dubluj zamówienie" - AJAX POST, otwarcie panelu edycji kopii
  $(document).on('click', '[data-action="duplicate"]', function() {
    const btn = $(this)
    const url = btn.data('url')
    btn.prop('disabled', true).find('i').removeClass('fa-copy').addClass('fa-spinner fa-spin')

    $.ajax({
      url: url,
      method: 'POST',
      dataType: 'json',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        if (data.redirect) {
          // Otwórz panel edycji zdublowanego zamówienia
          const link = $('<a>', {
            href: data.redirect,
            'data-panel': true,
            'data-panel-title': 'Edycja kopii zamówienia',
            'data-panel-icon': 'fa-pen-to-square',
            'data-panel-push-state': 'true',
            'data-panel-dirty': 'true'
          })
          $('body').append(link)
          link[0].click()
          link.remove()
        }
        // Odśwież tabelę zamówień
        location.reload()
      },
      error: function() {
        alert('Nie udało się zdublować zamówienia')
        btn.prop('disabled', false).find('i').removeClass('fa-spinner fa-spin').addClass('fa-copy')
      }
    })
  })
})
